import { sellerDashboard } from './sellerDashboard';
import { sitewide } from './sitewide';

export const tracking = {
  sellerDashboard,
  sitewide,
};
